import { Dropdown, Menu } from '@recruit-robin/robin-theme/web-components';
import { DotsVertical } from '@recruit-robin/robin-theme/web-icons';
import { useStyles } from './Header.styles';

const Title = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();

  return <div css={classes.title}>{children}</div>;
};

const TitleDetails = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();

  return <div css={classes.titleDetails}>{children}</div>;
};

const TitleDetailsButton = ({ options }: { options: React.ReactNode }) => {
  const classes = useStyles();

  console.log(options);
  if (!options) {
    return null;
  }

  return (
    <Dropdown
      placement="bottom-end"
      flipMenu={false}
      autoUpdateMenuPosition
      renderMenu={<Menu.Root customCss={classes.titleDetailsButtonMenu}>{options}</Menu.Root>}>
      {({ isOpen }) => (
        <div css={[classes.titleDetailsButton, isOpen && classes.titleDetailsButtonActive]}>
          <DotsVertical size={18} />
        </div>
      )}
    </Dropdown>
  );
};

const Subtitle = ({ children }: { children: React.ReactNode }) => {
  const classes = useStyles();

  return <div css={classes.subtitle}>{children}</div>;
};

export const Header = ({
  icon,
  title,
  subtitle,
}: {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle: React.ReactNode;
}) => {
  const classes = useStyles();

  return (
    <div css={classes.header}>
      <div css={classes.icon}>{icon}</div>

      <div css={classes.content}>
        {title}
        {subtitle}
      </div>
    </div>
  );
};

Header.Title = Title;
Header.TitleDetails = TitleDetails;
Header.TitleDetailsButton = TitleDetailsButton;
Header.Subtitle = Subtitle;
